var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLadyWithCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 282,
    viewBox: "0 0 226 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_25993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.796 136.39C112.796 136.39 158.484 133.666 158.484 67.5483L135.702 61.9766C135.702 61.9766 133.35 98.5022 102.891 104.322L112.796 136.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.891 104.322L112.796 136.39L96.5762 107.719L102.891 104.322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.2711 280.634C131.052 280.634 164.923 275.202 164.923 268.5C164.923 261.799 131.052 256.366 89.2711 256.366C47.4899 256.366 13.6196 261.799 13.6196 268.5C13.6196 275.202 47.4899 280.634 89.2711 280.634Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3916 65.071C24.3916 92.4343 46.6784 113.483 74.0417 113.483C101.405 113.483 123.692 92.4343 123.692 65.071C123.692 37.7077 101.529 15.4209 74.0417 15.4209C46.5546 15.4209 24.3916 37.5839 24.3916 65.071Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 3.38649,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.205 107.54C96.205 107.54 93.9763 99.8638 110.815 118.684C124.187 133.542 119.235 161.276 119.235 161.276C119.235 161.276 120.349 193.84 134.959 215.136L24.5156 236.556C24.5156 236.556 33.1827 182.201 33.678 166.724C34.1733 151.247 41.4784 112.617 66.8606 107.54C92.2429 102.464 96.205 107.54 96.205 107.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.368 208.573L115.768 256.49H102.396L94.7189 208.573H84.3184V256.49H69.7081L64.2603 203.868L117.625 190.001L118.368 208.573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.205 107.54L93.7287 132.303L74.042 113.483",
    stroke: "white",
    strokeWidth: 1.23816,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3916 65.4421C24.3916 92.8054 46.6784 113.854 74.0417 113.854C101.405 113.854 123.692 92.8054 123.692 65.4421C123.692 38.0788 101.529 15.792 74.0417 15.792C46.5546 15.792 24.3916 38.0788 24.3916 65.4421Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 3.38649,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7176 3.78226C68.7176 3.78226 104.872 -14.171 120.968 27.3073C134.588 62.5948 132.359 57.3945 140.531 67.2998C148.703 77.205 116.758 98.3775 117.625 85.2531C119.111 63.2138 118.368 21.4879 82.9565 23.3452C63.5174 24.3357 59.5553 25.2024 57.9457 42.5366C56.3361 59.747 63.2697 58.1374 65.2508 72.2524C67.2318 86.9865 60.2982 126.236 5.20014 123.884C5.20014 123.884 36.5255 117.198 13.2482 98.749C-10.0292 80.3004 -8.66723 -14.9139 68.7176 3.78226Z",
    fill: "#32BEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0886 110.264C56.0886 110.264 25.2584 130.322 22.0392 155.209C18.82 180.096 40.8592 184.925 40.8592 184.925L56.46 159.542L56.0886 110.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4256 162.649C51.3865 160.939 52.9553 158.113 51.9295 156.336C50.9038 154.56 47.672 154.506 44.7111 156.215C41.7502 157.925 40.1814 160.751 41.2071 162.527C42.2328 164.304 45.4646 164.358 48.4256 162.649Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.666,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3916 65.071C24.3916 92.4343 46.6784 113.483 74.0417 113.483C101.405 113.483 123.692 92.4343 123.692 65.071C123.692 37.7077 101.529 15.4209 74.0417 15.4209C46.5546 15.4209 24.3916 37.5839 24.3916 65.071Z",
    stroke: "#020203",
    strokeWidth: 3.38649,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5938 262.309C68.5938 262.309 75.156 255.871 76.1465 252.899H81.5944L80.2324 264.167H76.7656L76.518 257.233C76.518 257.233 75.2798 265.281 69.7081 264.91C64.1364 264.538 68.5938 262.309 68.5938 262.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.12 262.309C118.12 262.309 109.453 255.871 108.215 252.899H105.615L102.891 264.167H107.348L107.596 257.233C107.596 257.233 109.206 265.281 116.511 264.91C123.816 264.538 118.12 262.309 118.12 262.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2903 56.0334C87.2903 56.0334 77.7565 50.0903 74.042 60.7384",
    stroke: "black",
    strokeWidth: 2.47632,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 53.8031C104.748 53.8031 100.415 47.117 93.8525 51.0792",
    stroke: "black",
    strokeWidth: 2.47632,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1073 142.828L43.8306 195.574L78.6228 206.717L92.3663 150.257L54.1073 142.828Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.928618,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8787 149.143L50.0215 159.791",
    stroke: "black",
    strokeWidth: 0.928618,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3363 146.295L88.8999 152.114L76.7659 203.003L46.8025 194.335L56.3363 146.295Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7639 167.714C37.6401 161.028 47.0501 157.685 53.1171 160.781C59.184 163.876 61.6604 171.305 58.565 177.248C55.4696 183.191 48.0406 185.544 41.9736 182.448C37.1448 179.972 37.8877 174.276 37.7639 167.714Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.56695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3174 167.466L49.2788 166.6",
    stroke: "#020203",
    strokeWidth: 2.56695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1935 173.905L48.6597 172.667",
    stroke: "#020203",
    strokeWidth: 2.56695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8699 144.809L66.3651 143.199L78.7467 145.676L78.0038 147.409",
    stroke: "white",
    strokeWidth: 0.928618,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6513 57.518L73.2988 55.4131",
    stroke: "black",
    strokeWidth: 2.47632,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6136 53.8043L79.2422 51.8232",
    stroke: "black",
    strokeWidth: 2.47632,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4621 140.476C97.7187 140.476 99.5481 138.646 99.5481 136.39C99.5481 134.133 97.7187 132.304 95.4621 132.304C93.2055 132.304 91.3762 134.133 91.3762 136.39C91.3762 138.646 93.2055 140.476 95.4621 140.476Z",
    fill: "#744FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.224 66.5506C159 67.0571 162.176 58.7212 159.869 53.1641C157.447 47.5969 151.381 45.0859 146.161 47.5384C140.94 49.9908 138.619 56.5391 140.926 62.0962C142.746 66.563 147.553 66.1697 153.224 66.5506Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.2394,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.641 32.0868L150.694 1.14453L130.827 40.275L191.774 71.2173L211.641 32.0868Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2.42773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.454 37.0702L177.102 25.2233M197.978 41.8605L174.626 30.0136M193.323 51.2614L169.675 39.5941M181.75 51.7439L167.419 44.4442",
    stroke: "#868686",
    strokeWidth: 1.26116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.74 41.1282L144.925 33.5354C143.354 32.7301 142.697 30.693 143.503 29.1217L151.096 14.3068C151.901 12.7355 153.938 12.0789 155.509 12.8842L170.324 20.4771C171.895 21.2824 172.552 23.3194 171.747 24.8907L164.154 39.7057C163.348 41.2769 161.536 42.0486 159.74 41.1282Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2.23755,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 33.4214C144.7 33.4214 149.044 27.7115 152.532 28.6487C156.244 29.7009 159.83 32.1056 159.83 32.1056C159.83 32.1056 162.139 38.1074 159.849 41.4688L144.585 33.6459L144.7 33.4214Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.842 30.6686C165.602 28.3228 165.937 24.1839 163.591 21.4242C161.246 18.6644 157.107 18.3288 154.347 20.6745C151.587 23.0203 151.252 27.1591 153.597 29.9189C155.943 32.6786 160.082 33.0143 162.842 30.6686Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 1.11865,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.345 24.202C157.774 23.3967 157.774 23.3967 157.1 23.0516C153.175 20.7564 153.021 24.9287 152.238 24.2441C151.679 23.6745 152.715 21.6543 153.175 20.7564C154.325 18.5117 157.036 18.2002 157.6 18.2059C160.535 18.0095 162.549 19.6089 162.998 19.8389C164.564 21.2082 165.111 22.9058 165.221 23.2453C165.877 25.2824 165.521 27.0837 165.176 27.7571C164.595 29.4435 163.461 29.9962 163.237 29.8812C163.012 29.7661 164.491 28.54 163.944 26.8424C163.725 26.1634 163.052 25.8183 162.493 25.2487C161.371 24.6734 160.916 25.0073 159.345 24.202Z",
    fill: "#F22165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.842 30.6686C165.602 28.3228 165.937 24.1839 163.591 21.4242C161.246 18.6644 157.107 18.3288 154.347 20.6745C151.587 23.0203 151.252 27.1591 153.597 29.9189C155.943 32.6786 160.082 33.0143 162.842 30.6686Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.11865,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.585 48.6034C144.585 48.6034 150.157 45.6318 153.995 47.3652C157.834 49.0986 155.976 54.1751 149.29 55.4132H145.576",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.585 48.6034C144.585 48.6034 150.157 45.6318 153.995 47.3652C157.834 49.0986 155.976 54.1751 149.29 55.4132H145.576",
    stroke: "#020203",
    strokeWidth: 2.29728,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4795 89.5205C77.4795 89.5205 81.3178 96.2066 85.2799 94.4731C85.2799 94.4731 87.7562 93.6064 80.8225 91.2539L77.4795 89.5205Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_25993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.345,
    height: 281.062,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadyWithCard);
export default __webpack_public_path__ + "static/media/lady-with-card.cd5efaf5ea6723f395cac98f1895a53c.svg";
export { ForwardRef as ReactComponent };